export enum Provider {
  GoogleBusiness = 'GoogleBusiness',
  OfficeBusiness = 'OfficeBusiness',
  OfficeHome = 'OfficeHome',
  GoogleHome = 'GoogleHome'
}
